export const TOPIC_SOURCES = ['public_editorial', 'private_ai', 'community_contribution', 'github_trending'] as const;

export type TopicSource = (typeof TOPIC_SOURCES)[number];

/** FAQ item shared by Topic and Chapter metadata. */
export interface FaqItem {
	question: string;
	answer: string;
}
